import {PageBase} from "@/app2/shared/layouts/PageBase";
import {makeStyles} from "tss-react/mui";
import {Box, Tab, Tabs, Typography} from "@mui/material";
import {palette} from "@/constants";
import {MyProgressPageContainer} from "./MyProgressPageContainer";
import {MyCourses} from "./MyCourses";
import {MyRecentCompletedModules} from "./MyRecentCompletedModules";
import {MyFinishedCourses} from "./MyFinishedCourses";
import {useMq} from "@buildwitt/shapeshift-common/v1/hooks";
import {useState} from "react";
import {PageTitle} from "@/app2/shared/components/pageTitle";
import {useSSTranslation} from "@/i18n/useSSTranslation";

const useStyles = makeStyles()((theme) => ({
	pageBase: {
		[theme.breakpoints.up("lg")]:{
			"& [class*='menuIcon']": {
				display: "none"
			}
		}
	},
	container: {
		[theme.breakpoints.up("sm")]:{
			padding: "0 20px"
		}
	},
	centeredContainer: {
		display: "grid",
		gridTemplateColumns: "repeat(auto-fill, minmax(350px, 1fr))",
		justifyContent: "stretch",
		gap: "20px"
	},
	tabs: {
		height: "70px",
		minHeight: "70px",
		borderBottom: palette.grey10 + " 1px solid",
		width: "100%",
		padding: "0 15px"
	}
}));

export const MyProgressPage: React.FC = () => {
	const {classes} = useStyles();
	const mq = useMq();
	const {t} = useSSTranslation();
	const [tab, setTab] = useState<"recent" | "active" | "complete">("recent");

	return (
		<PageBase className={classes.pageBase} contentWidth="1420px" disableSideBar>
			<PageTitle
				sx={{margin: "0 0 0 20px"}}
				enableDayStreak
				applyNewTitleStyle={true}
				title={t("page_progress_title", "My Progress")}
			/>
			<Box className={classes.container}>
				{mq.mobile && <Tabs variant="scrollable" className={classes.tabs} value={tab} onChange={(_e, v) => setTab(v)} >
					<Tab label={t("page_progress_recent_activity", "Recent Activity")} value="recent"/>
					<Tab label={t("page_progress_active_courses", "Active Courses")} value="active"/>
					<Tab label={t("page_progress_finished_courses", "Finished courses")} value="complete"/>
				</Tabs>}
				<Box className={classes.centeredContainer}>
					{(!mq.mobile || tab == "recent") && <MyProgressPageContainer title={t("page_progress_recent_activity", "Recent Activity")} subtitle={t("page_progress_recent_activity_subtitle", "See what you've completed so far")}>
						<MyRecentCompletedModules />
					</MyProgressPageContainer>}
					{(!mq.mobile || tab == "active") && <MyProgressPageContainer title={t("page_progress_active_courses", "Active Courses")} subtitle={t("page_progress_active_courses_subtitle", "Jump back into courses you participate in")}>
						<MyCourses />
					</MyProgressPageContainer>}
					{(!mq.mobile || tab == "complete") && <MyProgressPageContainer title={t("page_progress_finished_courses", "Finished courses")} subtitle={t("page_progress_finished_courses_subtitle", "See what courses you've completed so far")}>
						<MyFinishedCourses />
					</MyProgressPageContainer>}
				</Box>
			</Box>
		</PageBase>
	);
}
